let reg = /^[\w.\+]+@\w+.\w{2,}(?:.\w{2})?$/;

export function EmailValidation(email) {
    return reg.test(email);
}
